import { useSelector } from "react-redux";
import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";
import {
  donation1,
  donation2,
  donation3,
  donation4,
  donation5,
} from "assets/icons/index";

const DonationWays = () => {
  const { t, i18n } = useTranslation();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  */}
        <MainTitle title={t("Donation Ways")} />

        <section
          className={`px-[20px] lg:px-0 w-full my-[80px] text-[20px] ${
            i18n.language === "en" ? "font-Poppins" : "font-Almarai"
          } `}
        >
          <div className="mainContainer flex flex-col gap-12">
            <div className="w-full h-[65px] hover:bg-first_color/25 duration-300 shadow-shadow_main px-12 py-4 flex items-center gap-5 rounded-[15px]">
              <img src={donation1} alt="" />
              <p>{t("Direct Donation")}</p>
            </div>

            <div className="w-full flex flex-col lg:flex-row items-center gap-11 ">
              <div className="w-full h-[65px] shadow-shadow_main px-12 py-4 flex items-center gap-5 rounded-[15px] hover:bg-first_color/25 duration-300">
                <img src={donation2} alt="" />
                <p>{t("Donate via SMS")}</p>
              </div>

              <div className="w-full h-[65px] shadow-shadow_main px-12 py-4 flex items-center gap-5 rounded-[15px] hover:bg-first_color/25 duration-300">
                <img src={donation3} alt="" />
                <p>{t("Donate via Bank Account")}</p>
              </div>
            </div>

            <div className="w-full flex flex-col lg:flex-row items-center gap-11 ">
              <div className="w-full h-[65px] shadow-shadow_main px-12 py-4 flex items-center gap-5 rounded-[15px] hover:bg-first_color/25 duration-300">
                <img src={donation4} alt="" />
                <p>{t("Subscriptions")}</p>
              </div>

              <div className="w-full h-[65px] shadow-shadow_main px-12 py-4 flex items-center gap-5 rounded-[15px] hover:bg-first_color/25 duration-300">
                <img src={donation5} alt="" />
                <p>{t("Website Representative")}</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default DonationWays;
